export const getAggregatedResultCount = () => ({
  both: {
    totalMatches: null,
    matchesWon: null,
    matchesLost: null,
    __typename: 'AggregatedMatchUpCount',
  },
  singles: {
    totalMatches: null,
    matchesWon: null,
    matchesLost: null,
    __typename: 'AggregatedMatchUpCount',
  },
  doubles: {
    totalMatches: null,
    matchesWon: null,
    matchesLost: null,
    __typename: 'AggregatedMatchUpCount',
  },
})
